import { FC } from 'react'
import { styled } from '@mui/material/styles'
import { sanitizeHtml } from 'utils'

const StatementContainer = styled('div')(({ theme }) => ({
  lineHeight: 1.6,
  wordBreak: 'break-word',
  p: {
    ...theme.typography.body1
  },
  h1: {
    ...theme.typography.h1
  },
  h2: {
    ...theme.typography.h2
  },
  h3: {
    ...theme.typography.h3
  },
  h4: {
    ...theme.typography.h4
  },
  h5: {
    ...theme.typography.h5
  },
  h6: {
    ...theme.typography.h6
  }
}))

interface ConsentContentProps {
  statement: string
  ariaLabel?: string
}

const ConsentContent: FC<ConsentContentProps> = ({ statement, ariaLabel }) => {
  if (!statement) {
    return null
  }

  return (
    <StatementContainer
      role='document'
      aria-label={ariaLabel}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(statement) }}
    />
  )
}

export default ConsentContent
